import { render, staticRenderFns } from "./EmptyStates.vue?vue&type=template&id=39640146&scoped=true&"
import script from "./EmptyStates.vue?vue&type=script&lang=js&"
export * from "./EmptyStates.vue?vue&type=script&lang=js&"
import style0 from "./EmptyStates.vue?vue&type=style&index=0&id=39640146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39640146",
  null
  
)

export default component.exports